import { Button, Modal, Radio, Stack, Text } from '@mantine/core';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IProduct } from '../../../interfaces/Product';

export default function SelectProductOptionModal({
  opened,
  onClose,
  product,
  isExpress = false,
  onConfirm
}: {
  opened: boolean;
  onClose: () => void;
  product: IProduct | null;
  isExpress?: boolean;
  onConfirm: (payload: {
    optionId: string;
    price: number;
    expressPrice: number;
    label: string;
  }) => void;
}) {
  const { t } = useTranslation(['NewOrder', 'FieldName']);
  const [selectedId, setSelectedId] = useState<string | null>(null);

  const activeOptions = useMemo(() => {
    const opts = (product?.priceOptions || []).filter((o) => o?.isActive !== false);
    return opts;
  }, [product]);

  useEffect(() => {
    if (!product) return;
    // Preselect default if exists, else first
    const def = activeOptions.find((o) => o.isDefault);
    setSelectedId(def?._id || activeOptions[0]?._id || null);
  }, [product, activeOptions]);

  if (!product || !opened) return null;

  return (
    <Modal
      data-testid="select-product-option-modal"
      opened={opened}
      onClose={onClose}
      title={t('NewOrder:selectVariant')}>
      <Stack>
        <Radio.Group value={selectedId} onChange={setSelectedId}>
          <Stack>
            {activeOptions.map((opt) => (
              <Radio
                key={opt._id}
                value={opt._id as string}
                label={`${opt.label} — $${(isExpress ? opt.expressPrice : opt.price).toFixed(2)}`}
              />
            ))}
          </Stack>
        </Radio.Group>
        {activeOptions.length === 0 && (
          <Text size="sm" c="dimmed">
            {t('NewOrder:noVariants') || 'No hay variaciones activas para este producto.'}
          </Text>
        )}
        <Button
          data-testid="select-product-option-submit"
          disabled={!selectedId}
          onClick={() => {
            const selected = activeOptions.find((o) => (o._id as string) === selectedId);
            console.log('selected', selected);
            if (!selected) return;
            onConfirm({
              optionId: selected._id as string,
              price: selected.price,
              expressPrice: selected.expressPrice,
              label: selected.label
            });
          }}>
          {t('CommonButtons:select')}
        </Button>
      </Stack>
    </Modal>
  );
}
